/**
 * A navigation that should have signed the user in is remembered for the tab (sessionStorage, a timestamp). Another
 * one this soon means it did not stick — Identity Server keeps failing, the cookie does not come back — so the chat
 * stops and lets the user sign in by hand instead of looping (ADR-0004 §2.3, §2.5).
 */
export const ATTEMPT_WINDOW_MS = 60_000;

/** The panel's silent login after a 401. */
export const SILENT_LOGIN_KEY = 'gasbi-ai.silent-login';
/** The full page's top-level login after a 401. */
export const PAGE_LOGIN_KEY = 'gasbi-ai.page-login';
/** The silent login that switches the session to the host app's user, per that user. */
export const userSwitchKey = (sub: string) => `gasbi-ai.user-switch.${sub}`;

export const attemptedRecently = (key: string): boolean => {
  try {
    const attemptedAt = Number(window.sessionStorage.getItem(key));
    return attemptedAt > 0 && Date.now() - attemptedAt < ATTEMPT_WINDOW_MS;
  } catch {
    // Storage blocked: an attempt cannot be remembered, so never navigate on our own.
    return true;
  }
};

export const rememberAttempt = (key: string) => {
  try {
    window.sessionStorage.setItem(key, String(Date.now()));
  } catch {
    // Storage blocked: attemptedRecently already answers true.
  }
};

export const forgetAttempt = (key: string) => {
  try {
    window.sessionStorage.removeItem(key);
  } catch {
    // Storage blocked: nothing was remembered.
  }
};
